<mat-form-field appearance="fill">
  <mat-label>Select a region</mat-label>
  <mat-select [(value)]="selectedRegionId" (selectionChange)="onSelectionChange($event.value)" [disabled]="isLoading">
    <mat-option [value]="'all'">All Regions</mat-option>
    <mat-option *ngFor="let region of regions; trackBy: trackById" [value]="region.id">
      {{ region.name }}
    </mat-option>
  </mat-select>
  <ng-container *ngIf="isLoading">
    <mat-progress-bar class="loading-bar" mode="indeterminate"></mat-progress-bar>
  </ng-container>
</mat-form-field>
